import { Flex } from '@styles';
import { arrayOf, bool, number, object, shape } from 'prop-types';
import React from 'react';

import ProgressItem from './ProgressItem';

const ProgressBar = ({
  containerProps = {},
  currentStep,
  items,
  withCorrection,
}) => (
  <Flex
    flexDirection="row"
    gap={4}
    height={6}
    opacity={0.3}
    width="100%"
    {...containerProps}
  >
    {items?.map((item, index) => (
      <ProgressItem
        key={item?.id}
        isCorrect={item?.is_correct}
        isPassed={index <= currentStep}
        numberOfItems={items?.length}
        withCorrection={withCorrection}
      />
    ))}
  </Flex>
);

ProgressBar.propTypes = {
  containerProps: object,
  currentStep: number.isRequired,
  items: arrayOf(
    shape({
      id: number,
      isCorrect: bool,
      isPassed: bool.isRequired,
    })
  ).isRequired,
  withCorrection: bool,
};

ProgressBar.defaultProps = {
  containerProps: {},
  withCorrection: false,
};

export default ProgressBar;
